import { Component, OnInit, isDevMode } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-quote-referral-info',
  templateUrl: './quote-referral-info.component.html',
  styleUrls: ['./quote-referral-info.component.scss']
})
export class QuoteReferralInfoComponent implements OnInit {
  form!: FormGroup
  inDev = isDevMode()
  
  constructor(private rootFormGroup: FormGroupDirective) {    
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control
  }

  get showAgentNameField(): boolean {
    return this.form.get('referralInfo')?.get('hasAgentContact')?.value === 'Yes';
  }
}
